export default __webpack_public_path__ + "static/media/Trend7.bcd6d964.svg";